import {
    chakra,
    Flex,
    Box
} from '@chakra-ui/react';

export const WelcomePageContainer = chakra(Box, {
    label: 'WelcomePageContainer',
    baseStyle: {
        p: '0 15px',
        m: '0 auto'
    }
});

export const WelcomePageRow = chakra(Flex, {
    label: 'WelcomePageRow',
    baseStyle: {
        direction: 'column',
        h: '100%',
        m: 'auto',
        maxW: '1200px',
        pt: '45px'
    }
});

export const WelcomePageDucsContainer = chakra(Box, {
    label: 'WelcomePageDucsContainer',
    baseStyle: {
        [`.ppp-ducs-overridable.ppp-row-type-Breakout, 
        .ppp-ducs-overridable.ppp-row-type-heading, 
        .ppp-ducs-overridable.ppp-welcome-row-type-heading`]: {
            mb: '20px',
            p: '20px 15px 15px',
            bg: '#fff',
            borderRadius: '7px',
            boxShadow: '4px 4px 0 rgba(0, 0, 0, 0.1)',
            transition: 'all .2s ease-in-out'
        },
        [`.ppp-ducs-overridable.ppp-module-type-table th, 
        .ppp-ducs-overridable.ppp-module-type-table td`]: { border: '0 white' },
        ['.ppp-ducs-overridable.ppp-module-type-TextBox']: {
            fontSize: '16px',
            color: 'rgb(68, 68, 68)',
            ['h2']: {
                fontSize: '30px',
                color: 'rgb(25, 129, 196)'
            },
            ['strong']: { color: 'rgb(0, 172, 232)' },
            ['a']: { color: 'rgb(0, 172, 232)' }
        },
        [`.ppp-ducs-overridable.ppp-row-type-Standard,
          .ppp-ducs-overridable.ppp-row-type-standard,
          .ppp-ducs-overridable.ppp-welcome-row-type-standard`]: {
            margin: '10px 0',
            ['.ppp-ducs-overridable.ppp-module-type-PortalWelcome']: {
                p: '20px 15px 15px',
                bg: '#fff',
                borderRadius: '7px',
                boxShadow: '4px 4px 0 rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s ease-in-out',
                ['h2, p']: {
                    ['span']: {
                        bg: 'rgb(238, 242, 245)',
                        ['svg > path']: { fill: 'rgb(25, 129, 196) !important' }
                    }
                },
                ['h2']: { color: 'rgb(25, 129, 196)' },
                ['& hover']: {
                    cursor: 'pointer',
                    bgColor: 'rgb(25, 129, 196)',
                    boxShadow: '4px 4px 0 rgba(0, 0, 0, 0.25)',
                    ['h2, p']: {
                        color: 'fff',
                        ['span']: {
                            bg: 'rgb(25, 129, 196',
                            ['svg > path']: { fill: '#fff !important' }
                        }
                    }
                }
            }
        }
    }
});
